import React from "react";
import Navigation from "./Navigation";
import Button from "components/UI/Button";
import Bargraph from "./BarGraph";
import PieChart from "./PieChart";
import Commons from "components/Commons";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "./style.css";
import theme from "../../../Theme/theme"

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { toast } from "react-toastify";

import axios from "axios";

import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";
import { formatNumber } from "../../../common/Utils";
import moment from "moment";
import { Constants } from "../../../common/constants";

const DEFAULT_START_DATE = "01/01/2016"
const TIME_RANGE = "Select Time Range"
const TIME_RANGE_ERROR_NOTE = "Please select valid date range";

const access_level = localStorage.getItem("access_level");
const timeFilter = {
  DAY: "Day",
  WEEK: "Week",
  MONTH: "Month",
  YEAR: "Year",
  ALL: "All",
}

const EMPTY_SESSION_DETAILS = {
  gym_cost: {
    gym_time_value: 0, revenue: 0
  },
  time_spend_ms: 0,
  sessions_count: 0,
}

const style = {
  navigationWrapper: {
    display: "flex",
    justifyContent: "center",
    margin: "25px 200px 0px 100px"
  },
  navigationFiller: {
    width: "100%",
    borderBottom: "1px solid #ccc"
  },
  exportButtonWrapper: {
    display: "flex",
    justifyContent: "flex-end"
  },
  exportButton: {
    width: "200px",
    fontFamily: "arial",
    fontSize: "20px",
    marginRight: "-100px",
    marginBottom: "-1px"
  },
  chartsWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "25px",
    flexWrap: "wrap"
  },
  chart: {
    margin: "10px"
  },
  flexColumnWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  userFilter: {
    fontSize: 25,
    fontFamily: theme.font.avenirMediumOblique,
    color: theme.color.thickGrey,
    textAlign: 'center',
    borderRadius: 8,
    border: "1px solid " + theme.color.tableSeparatorGrey,
    paddingLeft: 20,
    paddingRight: 20,
    marginTop: 12,
    lineHeight: "40px"
  },
  timerDescription: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 15,
    borderWidth: 0,
    width: 150,
    marginTop: 0,
    lineHeight: "20px"
  },
  flexAlignSpaceBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center'
  },
  filterContainer: {
    width: 380,
    height: "100%",
    flexDirection: "column",
  },
};

class AnalyticsScreen extends React.Component {
  constructor() {
    super();
    this.data = null;
    this.state = {
      data: { some: "Some test data so that that bug goes away" },
      fetched: false,
      duration: 0,
      analyticsData: { some: "Some test data so that that bug goes away" },
      selectedTimeFilter: timeFilter.ALL,
      startDate: "",
      endDate: "",
    };
  }

  fetchAnalyticsData() {
    const toastId = toast("Fetching Analytics Data");
    const access_token = localStorage.getItem("access_token")
    let url = API_URL + "/admin/analytics";
    let start = this.state.startDate ? this.formatDate(this.state.startDate) : this.formatDate(DEFAULT_START_DATE);
    let end = this.state.endDate ? this.formatDate(this.state.endDate) : this.formatDate(new Date());
    url = url + '?from=' + start + '&to=' + end
    axios
      .get(url, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId)
        this.data = res.data;
        this.setState({
          ...this.state,
          data: res.data,
          fetched: true,
          analyticsData: res.data.data,
          session: typeof res.data.overview[2] === 'object' ? res.data.overview[2] : EMPTY_SESSION_DETAILS
        });
      })
      .catch(err => {
        toast.dismiss(toastId)
        ERROR_HANDLE(err);
      });
  }

  formatDate = (date) => {
    let formatedDate = ""
    if(date) {
      formatedDate = moment(date).format("YYYY-MM-DD")
    }
    return formatedDate
  }

  exportAnalytics = d => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Analytics...");
    let url = API_URL + "/admin/export/analytics";
    let start = this.state.startDate ? this.formatDate(this.state.startDate) : this.formatDate(DEFAULT_START_DATE);
    let end = this.state.endDate ? this.formatDate(this.state.endDate) : this.formatDate(new Date());
    url = url + '?from=' + start + '&to=' + end
    axios
      .get(url, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "export.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  componentDidMount() {
    if (!this.state.fetched) {
      this.fetchAnalyticsData();
    }
  }

  setDuration = value => {
    this.fetchAnalyticsData();
    this.setState({
      ...this.state,
      duration: value,
      analyticsData: this.state.data.data[value]
    });
  };

  rotateArrayRight = (arr, times) => {
    let array = arr;
    for (var i = 0; i < times; i++) {
      array.unshift(array.pop(array.length - 1));
    }
  };
  rotateArrayLeft = (arr, times) => {
    let array = arr;
    for (var i = 0; i < times; i++) {
      array.push(array.shift(array[0]));
    }
  };
  getTimeZoneOffsetFormatted = () => {
    let offset = new Date().getTimezoneOffset() / 60;
    return offset;
  };

  updateSelectedTimeFilter(value) {
    let dayCount;
    switch (value) {
        case timeFilter.DAY:
            dayCount = 1;
            break;
        case timeFilter.WEEK:
            dayCount = 7;
            break;
        case timeFilter.MONTH:
            dayCount = 30;
            break;
        case timeFilter.YEAR:
            dayCount = 365;
            break;
        case timeFilter.ALL:
        default:
            dayCount = 0
    }
    this.setState({
        startDate: dayCount > 0 ? moment().subtract(dayCount, 'days') : "",
        endDate: dayCount > 0 ? moment() : "",
        selectedTimeFilter: value,
        showDateRangeError: false
    }, () => {
      this.fetchAnalyticsData();
    })
  }

  handleStartDateChange(date) {
    //update the start date only if it is less than or equal to end date and future date.
    if(!moment(date).isAfter(this.state.endDate) && !moment(date).isAfter(new Date())) {
      this.setState({
          startDate: date,
          showDateRangeError: false
      }, () => {
        this.fetchAnalyticsData();
      })
    } else {
      this.setState({
          showDateRangeError: true
      })
    }
  }

  handleEndDateChange(date) {
    //update the end date only if it is greater than or equal to start and less than or equal to future date.
    if(!moment(date).isBefore(this.state.startDate) && !moment(date).isAfter(new Date())) {
      this.setState({
        endDate: date,
        showDateRangeError: false
      }, () => {
        this.fetchAnalyticsData();
      })
    } else {
      this.setState({
        showDateRangeError: true
      })
    }
  }

  rangePicker = () => {
    let timeFilterComponent = [];
    timeFilterComponent.push(Object.keys(timeFilter).map((filter, index) => {
        const filterText = (Object.keys(timeFilter).length === index + 1)
          ? timeFilter[filter] 
          : timeFilter[filter] + " - "
        const filterTextStyle = (timeFilter[filter] === this.state.selectedTimeFilter)
          ? { ...style.filterText, ...{ fontWeight: theme.fontWeight.bold } } 
          : style.filterText
        return <div key={"timeFilter" + index} style={filterTextStyle} onClick={() => 
          this.updateSelectedTimeFilter(timeFilter[filter])
        }>{filterText}</div>
    }));
    return (
      <div style={{
        display:'flex',
        flex:1,
        alignSelf:'stretch',
        backgroundColor:'white',
        padding:20,
        width:200
      }}>
        <div style={{ ...style.filterContainer, ...style.flexAlignSpaceBetween }} >
          <div style={{ display: "flex", width: "100%", justifyContent: "space-around", marginTop: 30}}>
              <div style={style.flexColumnWrapper}>
                  <div style={{ ...style.userFilter, ...{ fontSize: 15, marginTop: 0, borderWidth: 0, lineHeight: "30px" } }}>{TIME_RANGE}</div>
                  <DatePicker
                      locale="en-us"
                      selected={this.state.startDate}
                      onChange={(date) => this.handleStartDateChange(date)}
                  />
                  <div style={{ ...style.userFilter, ...style.timerDescription }}><span style={style.separator} />{"to"}<span style={style.separator} /></div>
                  <DatePicker
                      locale="en-us"
                      selected={this.state.endDate}
                      onChange={(date) => this.handleEndDateChange(date)}
                  />
                  {this.state.showDateRangeError && <div style={{ color: theme.color.red, marginTop: 10 }}>{TIME_RANGE_ERROR_NOTE}</div>}
              </div>
          </div>
          <div style={{...style.filterText, ...{ fontWeight: theme.fontWeight.bold, fontSize: 30}}}>
            {this.state.selectedTimeFilter.toUpperCase()}
          </div>
          <div style={{ ...style.flexAlignSpaceBetween, ...{ marginBottom: 25 } }} >
              {timeFilterComponent}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const columns = [
      {
        Header: "Date",
        accessor: "date" // String-based value accessors!
      },
      {
        Header: "New Users",
        accessor: "newusers",
        Cell: props => <span className="number">{props.value}</span> // Custom cell components!
      },
      {
        Header: "Promocodes Applied",
        accessor: "promocodes",
        Cell: props => <span className="number">{props.value}</span> // Custom cell components!
      }
    ];
    if (this.state.fetched) {
      if (this.getTimeZoneOffsetFormatted() < 0) {
        this.rotateArrayRight(
          this.state.analyticsData.checkin_times[1],
          Math.abs(Math.ceil(this.getTimeZoneOffsetFormatted()))
        );
      } else {
        this.rotateArrayLeft(
          this.state.analyticsData.checkin_times[1],
          Math.abs(Math.floor(this.getTimeZoneOffsetFormatted()))
        );
      }
    }
    return (
      <div>
        {this.state.fetched ? 
          <div style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            backgroundColor:'white',
            flexGrow:1
          }}>
            <Overview overview={this.state.data.overview} session={this.state.session}/>
            {this.state.session != null && this.rangePicker()}
          </div>
          :
          ""
        }
        {access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_2
        ? null
      : <div>
      <div style={style.navigationWrapper}>
        <div
          style={{ ...style.exportButtonWrapper }}
        >
          <Button
            style={style.exportButton}
            type="primary"
            onClick={() => {
              this.exportAnalytics(this.state.duration);
            }}
          >
            Export
          </Button>
        </div>
      </div>

      <div style={style.chartsWrapper}>
        <div style={style.chart}>
          {this.state.fetched ? (
            <Bargraph
              xLabel="Time of day"
              yLabel="Frequency"
              title="Check-in Times"
              labels={this.state.analyticsData.checkin_times[0]}
              data={this.state.analyticsData.checkin_times[1]}
              style={{ height: "300px", width: "400px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div style={style.chart}>
          {this.state.fetched ? (
            <Bargraph
              xLabel="Duration"
              yLabel="Frequency"
              title="Workout Duration"
              labels={this.state.analyticsData.workout_duration[0]}
              data={this.state.analyticsData.workout_duration[1]}
              style={{ height: "300px", width: "400px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div style={style.chart}>
          {this.state.fetched ? (
            <Bargraph
              line
              xLabel="Date"
              yLabel="$"
              title="Transactions"
              labels={this.state.analyticsData.dates}
              data={this.state.analyticsData.transactions}
              style={{ height: "300px", width: "400px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div style={style.chart}>
          {this.state.fetched ? (
            <Bargraph
              line
              xLabel="Date"
              yLabel="Users"
              title="Registrations"
              labels={this.state.analyticsData.dates}
              data={this.state.analyticsData.registrations}
              style={{ height: "300px", width: "400px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div style={style.chart}>
          {this.state.fetched ? (
            <PieChart
              colors={["#00cec9", "rgb(0,124,235)","#FF6347"]}
              labels={this.state.analyticsData.gender_breakdown[0]}
              data={this.state.analyticsData.gender_breakdown[1]}
              title="Gender Breakdown"
              style={{ height: "300px", width: "400px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div style={style.chart}>
          {this.state.fetched ? (
            <PieChart
              title="Customers"
              style={{ height: "300px", width: "400px" }}
              labels={this.state.analyticsData.customers[0]}
              data={this.state.analyticsData.customers[1]}
              colors={["#00cec9", "rgb(0,124,235)"]}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      </div>}
      </div>
    );
  }
}

export default AnalyticsScreen;

const Overview = ({overview, session}) => {
  const style = {
    wrapper: {
      display: "flex",
      justifyContent:'center',
      padding:"30px 0px"
    }
  };
  if(access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_2) return null;
  return (<div style={style.wrapper}>
    <OverviewItem
      name="Users"
      value={overview[0]}
      index={0}
      source={require("assets/images/anal/users-anal.png")}
    />
    <OverviewItem
      name="Gyms"
      value={overview[1]}
      index={1}
      source={require("assets/images/anal/gyms-anal.png")}
    />
    {
      session != null && 
      <div style={{
        display: "flex",
        flexDirection:'row'
      }}>
        <div style={{
          width:1,
          alignSelf: 'stretch',
          backgroundColor:'#EAEAEA',
          marginLeft:20,
          marginRight:20
        }}/>
        <OverviewItem
          name="Revenue"
          value={session}
          index={2}
          source={require("assets/images/anal/revenue-anal.png")}
        />
        <OverviewItem
          name="Sessions"
          value={session}
          index={3}
          source={require("assets/images/anal/sessions-anal.png")}
        />
      </div>
    }
  </div>)
};

const OverviewItem = props => {
  console.log(props);
  const style = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginRight:"30px",
      marginLeft:"30px"
    },
    icon: {
      height: "80px",
      width: "80px",
      borderRadius: "100%",
      border: "none"
    },
    name: {
      fontFamily: "arial",
      fontSize: "40px",
      color: "#444445",
      margin: "10px 0px"
    },
    value: {
      color: "#00acc9",
      fontFamily: "arial",
      fontSize: "40px",
      margin: "0px 0px"
    }
  };
  return (
    <div style={style.wrapper}>
      <img style={style.icon} src={props.source} alt="Analytics" />
      <p style={style.name}>{props.name}</p>
      {/* <p style={style.value}>{props.value}</p> */}
      {getData(props.value, props.index)}
    </div>
  );
};

const getData = (data, index) => {
  let content = null;
  switch(index) {
    case 0:
      content = getUserData(data)
      break;
    case 1:
      content = getGymData(data)
      break;
    case 2:
      content = getRevenueData(data)
      break;
    case 3:
      content = getSessionData(data)
      break;
  }
  return content
}

const getUserData = data => {
  let active = formatNumber(data.users_count.active)
  let inactive =  formatNumber(data.users_count.inactive)
  let recurring = formatNumber(data.users_count.recurring)
  return <div style={{
      display: "flex",
      flexDirection: "row"
    }}>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Active</p>
      <p style={style.value}>{active ? active : '--'}</p>
    </div>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Inactive</p>
      <p style={style.value}>{inactive ? inactive : '--'}</p>
    </div>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Recurring</p>
      <p style={style.value}>{recurring ? recurring : '--'}</p>
    </div>
  </div>
}

const getGymData = data => {
  let active = formatNumber(data.gyms_count.active)
  let inactive = formatNumber(data.gyms_count.inActive)
  return <div style={{
      display: "flex",
      flexDirection: "row"
    }}>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Active</p>
      <p style={style.value}>{active ? active : '--'}</p>
    </div>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Inactive</p>
      <p style={style.value}>{inactive ? inactive : '--'}</p>
    </div>
  </div>
}

const getRevenueData = data => {
  let gtv = formatNumber(Math.round(data.gym_cost.gym_time_value))
  let gross = formatNumber(Math.round(data.gym_cost.revenue))
  return <div style={{
      display: "flex",
      flexDirection: "row"
    }}>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>GTV</p>
      <p style={style.value}>{gtv ? '$' + gtv : '--'}</p>
    </div>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Gross</p>
      <p style={style.value}>{gross ? '$' + gross : '--'}</p>
    </div>
  </div>
}

const getSessionData = data => {
  let minutes = formatNumber(Math.round(data.time_spend_ms/60000))
  let count = formatNumber(data.sessions_count)
  return <div style={{
      display: "flex",
      flexDirection: "row"
    }}>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Minutes</p>
      <p style={style.value}>{minutes ? minutes : '--'}</p>
    </div>
    <div style={{margin:10}}>
      <p style={{color:"var(--primary)"}}>Count</p>
      <p style={style.value}>{count ? count : '--'}</p>
    </div>
  </div>
}